import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Password Reset Unsuccessful ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Password Reset Complete")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Enter a New Password")
const _hoisted_4 = {
  key: 0,
  class: "medium-width-centered"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" The password reset link was invalid, possibly because it has already been used. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Request a New Link ")
const _hoisted_7 = {
  key: 1,
  class: "medium-width-centered"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Your password has been set.")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Log In")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Please enter your new password twice so we can verify you typed it in correctly. ", -1)
const _hoisted_11 = ["onSubmit"]
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "new_password1" }, "New password", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("small", {
  id: "new_password1_help",
  class: "form-text"
}, " Your password must contain at least 8 characters. ", -1)
const _hoisted_15 = {
  key: 0,
  class: "invalid-feedback js-form-error"
}
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "new_password2" }, "New password confirmation", -1)
const _hoisted_18 = {
  key: 0,
  class: "invalid-feedback js-form-error"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Setting Password ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Set Password")
const _hoisted_22 = {
  key: 2,
  class: "medium-width-centered"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Unable to communicate with the server. Please check your connection and try again. ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Try Again")

import api from "@virgodev/bazaar/functions/api";
import { nextTick, ref, watch } from "vue";
import isObjectEmpty from "@/methods/is_object_empty";
import scrollToFirstError from "@/methods/scroll_to_first_error";


export default /*#__PURE__*/_defineComponent({
  props: {
  uidb64: {
    type: String,
    required: true,
  },
  token: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props



const tokenStatus = ref<"checking" | "valid" | "invalid" | "error">("checking");
const formFields = ref({
  new_password1: "",
  new_password2: "",
});

const formErrors = ref<Record<string, string[]>>({});
watch(formErrors, () => {
  if (!isObjectEmpty(formErrors.value)) {
    nextTick(scrollToFirstError);
  }
});

const formSubmitting = ref(false);
const formSuccess = ref(false);

async function checkPasswordResetLink() {
  tokenStatus.value = "checking";

  const responseData = await api({
    url: "users/check_password_reset_link/",
    method: "POST",
    json: {
      uidb64: props.uidb64,
      token: props.token,
    },
  });

  if (responseData.status === 200) {
    tokenStatus.value = responseData.body.valid ? "valid" : "invalid";
  } else {
    tokenStatus.value = "error";
  }
}

async function submitForm() {
  formErrors.value = {};
  formSubmitting.value = true;

  const responseData = await api({
    url: "users/password_reset_submission/",
    method: "POST",
    json: {
      uidb64: props.uidb64,
      token: props.token,
      new_password1: formFields.value.new_password1,
      new_password2: formFields.value.new_password2,
    },
  });

  formSubmitting.value = false;

  if (responseData.status === 200) {
    formSuccess.value = true;
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

checkPasswordResetLink();

return (_ctx: any,_cache: any) => {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_TransitionSlide = _resolveComponent("TransitionSlide")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", null, [
      (tokenStatus.value === 'invalid')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_1
          ], 64))
        : (formSuccess.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_2
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _hoisted_3
            ], 64))
    ]),
    (tokenStatus.value === 'invalid')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_BaseAlert, { variant: "danger" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            to: { name: 'password_reset' },
            class: "btn btn-text"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]))
      : (formSuccess.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_BaseAlert, { variant: "success" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: { name: 'login' },
              class: "btn btn-text"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (tokenStatus.value === 'checking')
              ? (_openBlock(), _createBlock(_component_BaseSpinner, {
                  key: 0,
                  preset: "large"
                }))
              : (tokenStatus.value === 'valid')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_10,
                    _createVNode(_component_TransitionSlide, { mode: "out-in" }, {
                      default: _withCtx(() => [
                        (formErrors.value.non_field_errors !== undefined)
                          ? (_openBlock(), _createBlock(_component_BaseAlert, {
                              key: 0,
                              variant: "danger",
                              class: "js-form-error",
                              dismissible: "",
                              onDismissed: _cache[0] || (_cache[0] = ($event: any) => (formErrors.value = {}))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(formErrors.value.non_field_errors[0]), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("form", {
                      class: "well",
                      onSubmit: _withModifiers(submitForm, ["prevent"])
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _withDirectives(_createElementVNode("input", {
                          id: "new_password1",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.new_password1) = $event)),
                          class: _normalizeClass({ 'is-invalid': formErrors.value.new_password1 !== undefined }),
                          type: "password",
                          minlength: "8",
                          required: "",
                          "aria-describedby": "new_password1_help"
                        }, null, 2), [
                          [_vModelText, formFields.value.new_password1]
                        ]),
                        _hoisted_14,
                        (formErrors.value.new_password1 !== undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(formErrors.value.new_password1[0]), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _withDirectives(_createElementVNode("input", {
                          id: "new_password2",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.new_password2) = $event)),
                          class: _normalizeClass({ 'is-invalid': formErrors.value.new_password2 !== undefined }),
                          type: "password",
                          minlength: "8",
                          required: ""
                        }, null, 2), [
                          [_vModelText, formFields.value.new_password2]
                        ]),
                        (formErrors.value.new_password2 !== undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(formErrors.value.new_password2[0]), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("button", {
                        type: "submit",
                        disabled: formSubmitting.value,
                        class: "btn btn-text"
                      }, [
                        (formSubmitting.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_20,
                              _createVNode(_component_BaseSpinner)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_21
                            ], 64))
                      ], 8, _hoisted_19)
                    ], 40, _hoisted_11)
                  ], 64))
                : (tokenStatus.value === 'error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_component_BaseAlert, { variant: "danger" }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_BaseButton, {
                        class: "btn btn-text",
                        onClick: checkPasswordResetLink
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
          ], 64))
  ], 64))
}
}

})